import createAxios from "./axiosHttp";

function getPlans(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/plan/ql";
  return axios.post(urlPath, { pagination, query, sort });
}

function exportar(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/plan/ql/export";
  return axios.post(
    urlPath,
    { pagination, query, sort },
    { responseType: "arraybuffer" }
  );
}

function createPlan(body) {
  const axios = createAxios();
  const urlPath = "ttmm/plan";
  return axios.post(urlPath, body);
}

function getPlanById(planId) {
  const axios = createAxios();
  const urlPath = `ttmm/plan/${planId}`;
  return axios.get(urlPath);
}

function getInProgressPlans(date) {
  const axios = createAxios();
  const urlPath = "ttmm/plan/in-progress";
  return axios.get(urlPath, { params: { date } });
}

function getPlansByDateRange(dateFrom, dateTo) {
  const axios = createAxios();
  const urlPath = "ttmm/plan/by-date-range";
  return axios.get(urlPath, { params: { date_from: dateFrom, date_to: dateTo } });
}

function getPlanMap(planId, params = {}) {
  const axios = createAxios();
  const urlPath = `ttmm/plan/${planId}/map`;
  return axios.get(urlPath, { params });
}

function updatePlanStatus(plan_ids, status) {
  const axios = createAxios();
  const urlPath = `ttmm/plan/${plan_ids}/status`;
  return axios.put(urlPath, { plan_ids, status });
}

function assignVehicleToRoute(planId, vehicleId) {
  const axios = createAxios();
  const urlPath = `ttmm/plan/${planId}/route/vehicle/${vehicleId}`;
  return axios.put(urlPath);
}

function assignUnassignedStopToRoute(planId, routeId, stopIds, newOrder) {
  const axios = createAxios();
  const idParam = Array.isArray(stopIds) ? stopIds.join(",") : stopIds;
  const urlPath = `ttmm/plan/${planId}/route/${routeId}/stop/${idParam}`;
  return axios.put(urlPath, { new_order: newOrder });
}

function moveRouteStopToRoute(planId, sourceRouteId, routeStopIds, targetRouteId, newOrder) {
  const axios = createAxios();
  const idParam = Array.isArray(routeStopIds) ? routeStopIds.join(",") : routeStopIds;
  const urlPath = `ttmm/plan/${planId}/route/${sourceRouteId}/route_stop/${idParam}/move/route/${targetRouteId}`;
  return axios.put(urlPath, { new_order: newOrder });
}

function reorderRouteStop(planId, routeId, routeStopIds, newOrder) {
  const axios = createAxios();
  const idParam = Array.isArray(routeStopIds) ? routeStopIds.join(",") : routeStopIds;
  const urlPath = `ttmm/plan/${planId}/route/${routeId}/route_stop/${idParam}`;
  return axios.put(urlPath, { new_order: newOrder });
}

function unassignRouteStop(planId, routeId, routeStopIds) {
  const axios = createAxios();
  const idParam = Array.isArray(routeStopIds) ? routeStopIds.join(",") : routeStopIds;
  const urlPath = `ttmm/plan/${planId}/route/${routeId}/route_stop/${idParam}`;
  return axios.delete(urlPath);
}

function updateRouteStopInstructions(planId, routeId, routeStopId, instructions) {
  const axios = createAxios();
  const urlPath = `ttmm/plan/${planId}/route/${routeId}/route_stop/${routeStopId}/instructions`;
  return axios.post(urlPath, { instructions });
}

function deleteRoute(planId, routeId) {
  const axios = createAxios();
  const urlPath = `ttmm/plan/${planId}/route/${routeId}`;
  return axios.delete(urlPath);
}

function optimizePlanRoutes(planId) {
  const axios = createAxios();
  const urlPath = `ttmm/plan/${planId}/routes/optimize`;
  return axios.put(urlPath);
}

function createUnloadStop(planId, routeId, warehouseId, taskIds, newOrder, stopId = null) {
  const axios = createAxios();
  const urlPath = `ttmm/plan/${planId}/route/${routeId}/unload-stop`;
  const payload = {
    warehouse_id: warehouseId,
    task_ids: taskIds,
    new_order: newOrder,
    stop_id: stopId,
  };
  return stopId ? axios.put(urlPath, payload) : axios.post(urlPath, payload);
}

function createLoadStop(planId, routeId, warehouseId, taskIds, newOrder, stopId = null) {
  const axios = createAxios();
  const urlPath = `ttmm/plan/${planId}/route/${routeId}/load-stop`;
  const payload = {
    warehouse_id: warehouseId,
    task_ids: taskIds,
    new_order: newOrder,
    stop_id: stopId,
  };
  return stopId ? axios.put(urlPath, payload) : axios.post(urlPath, payload);
}

export const planService = {
  getPlans,
  exportar,
  createPlan,
  getPlanById,
  getInProgressPlans,
  getPlansByDateRange,
  getPlanMap,
  updatePlanStatus,
  assignVehicleToRoute,
  assignUnassignedStopToRoute,
  moveRouteStopToRoute,
  reorderRouteStop,
  unassignRouteStop,
  updateRouteStopInstructions,
  deleteRoute,
  optimizePlanRoutes,
  createUnloadStop,
  createLoadStop,
};
